'use strict';
import {module} from '../app';

module.service('Study', [
  '$http', 'authService', 'magViewApi', function ($http, authService, magViewApi) {
      return {
        get: function (ssn, sdate) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/study/loadStudy`;
        const model = {
          ssn,
          sdate
        };
        return $http.post(url, model);
        },
        loadStudies: function (ssn, location) {
          let url = `${authService.currentMagViewUrl()}${magViewApi}/study/loadStudies?ssn=${ssn}`;

          if(location){
            url += $`&location=${location}`;
          }

          return $http.get(url);
        },
        loadPriorStudies: function (ssn, sDate) {
          let url = `${authService.currentMagViewUrl()}${magViewApi}/study/loadPriorStudies?ssn=${ssn}&sDate=${sDate}`;
          return $http.get(url);
        },
      loadByAccessToken: function (accessToken, sdate) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/study/loadStudyByAccessToken`;
        const model = {
          accessToken,
          sdate
        };
        return $http.post(url, model);
      },
        getWorklist: function (ssn, sdate) {
        const url = `${authService.currentMagViewUrl()}/api/worklist?ssn=${ssn}&sdate=${sdate}`;
          return $http.get(url);
        },   
        post: function (patient) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/study`;
        return $http.post(url, patient);
        },
      generatePinNumber: function (ssn, sdate) {
        const url = `${authService.currentMagViewUrl()}/api/v2/survey/generatePin`;
        const model = {
          respondentId: ssn,
          respondentEntityId: sdate
        };
        return $http.post(url, model);
        },
        skipSurveyAndStartExam: function (ssn, sdate, newState, internalSkip) {
          let url = authService.currentMagViewUrl() + '/api/worklist/skipSurveyAndStartExam?ssn=' + ssn + '&sdate=' + sdate;

        if (newState && newState != "") {
            url += '&state=' + newState;
        }

        if (internalSkip) {
            url += '&internalSkip=' + internalSkip;
        }

          return $http.get(url);
        },
        startSurvey: function (ssn, sdate, pinNumber, noUpdateStatus) {
          let worklistModel = {
            ssn: ssn,
            sdate: sdate
          };

          if (!noUpdateStatus) {
            worklistModel.status = 'New'
          }

          if (pinNumber) {
            worklistModel.Pin = pinNumber;
          }

        const url = `${authService.currentMagViewUrl()}/api/worklist`;
        return $http.put(url, worklistModel);
        },
        getSurveyLog: function (surveyLogId) {
        const url = `${authService.currentMagViewUrl()}/api/survey/getSurveyLog?surveyLogId=${surveyLogId}`;
        return $http.get(url);
        },
        reviewSurvey: function (surveyLogId) {
        const url = `${authService.currentMagViewUrl()}/api/survey/makeSurveyReviewed?surveyLogId=${surveyLogId}`;
        return $http.post(url);
        },
        checkPinNumber: function(pinNumber){
        const url = `${authService.currentMagViewUrl()}/api/survey/checkPin?pin=${pinNumber}`;
        return $http.get(url);
        },
        generateSurveySecureKey: function(pinNumber){
        const url = `${authService.currentMagViewUrl()}/api/survey/generateSurveySecureKey?pin=${pinNumber}`;
        return $http.get(url);
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/domains/study.js